import React from 'react';

interface ComingSoonProps {
    title: string;
    description?: string;
}

const ComingSoon: React.FC<ComingSoonProps> = ({ title, description }) => {
    return (
        <div style={{ padding: '40px', textAlign: 'center', backgroundColor: '#fff', border: '1px solid #ccc', maxWidth: '600px', margin: '40px auto' }}>
            <h2 style={{ color: '#666', marginBottom: '20px' }}>{title}</h2>
            <p style={{ fontSize: '16px', lineHeight: '1.6' }}>
                {description || 'この機能は現在開発中です。今後のアップデートで提供される予定です。'}
            </p>
            <div style={{ marginTop: '30px', fontSize: '12px', color: '#999' }}>
                Status: Scheduled for Future Release
            </div>
        </div>
    );
};

export default ComingSoon;
